import * as types from "./types";

export const fetchHeatmapRequest = (payload) => ({
  type: types.FETCH_HEATMAP_REQUEST,
  payload,
});

export const fetchHeatmapSuccess = (payload) => ({
  type: types.FETCH_HEATMAP_SUCCESS,
  payload,
});

export const fetchHeatmapFailure = (error) => ({
  type: types.FETCH_HEATMAP_FAILURE,
  payload: error,
});
